import React from 'react';
import PropTypes from 'prop-types';
import SearchSectionNode from '@Pages/QueryBuilder/SearchSection/SearchSectionNode/SearchSectionNode';

function FieldsTab({ nodes, addToBuilder }) {
  return (
    <div className="query-builder-search-section__fields-tab">
      {nodes.length > 0 &&
        nodes.map((node, index) => (
          <SearchSectionNode
            // eslint-disable-next-line react/no-array-index-key
            key={`level-0-index-${index}`}
            node={node}
            level={0}
            index={index}
            addToBuilder={addToBuilder}
          />
        ))}
    </div>
  );
}

FieldsTab.propTypes = {
  nodes: PropTypes.array.isRequired,
  addToBuilder: PropTypes.func.isRequired,
};

export default FieldsTab;
